__turbopack_context__.v({
  "card": "services-section-module-scss-module__5Zfkyq__card",
  "cardDesc": "services-section-module-scss-module__5Zfkyq__cardDesc",
  "cardGlow": "services-section-module-scss-module__5Zfkyq__cardGlow",
  "cardHover": "services-section-module-scss-module__5Zfkyq__cardHover",
  "cardTitle": "services-section-module-scss-module__5Zfkyq__cardTitle",
  "container": "services-section-module-scss-module__5Zfkyq__container",
  "ctaBg": "services-section-module-scss-module__5Zfkyq__ctaBg",
  "ctaBlock": "services-section-module-scss-module__5Zfkyq__ctaBlock",
  "ctaButton": "services-section-module-scss-module__5Zfkyq__ctaButton",
  "ctaGradient": "services-section-module-scss-module__5Zfkyq__ctaGradient",
  "ctaInner": "services-section-module-scss-module__5Zfkyq__ctaInner",
  "ctaText": "services-section-module-scss-module__5Zfkyq__ctaText",
  "ctaTitle": "services-section-module-scss-module__5Zfkyq__ctaTitle",
  "features": "services-section-module-scss-module__5Zfkyq__features",
  "grid": "services-section-module-scss-module__5Zfkyq__grid",
  "iconWrap": "services-section-module-scss-module__5Zfkyq__iconWrap",
  "section": "services-section-module-scss-module__5Zfkyq__section",
  "servicesIconWiggle": "services-section-module-scss-module__5Zfkyq__servicesIconWiggle",
  "subtitle": "services-section-module-scss-module__5Zfkyq__subtitle",
  "title": "services-section-module-scss-module__5Zfkyq__title",
  "titleBlock": "services-section-module-scss-module__5Zfkyq__titleBlock",
  "titleLine": "services-section-module-scss-module__5Zfkyq__titleLine",
});
